import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  TextField,
  Button,
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import {
  Home as HomeIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  ExitToApp as ExitToAppIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const baseUrl = process.env.REACT_APP_APP_URL;

const BannerAdmin = () => {
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [banners, setBanners] = useState([]); // Initialize as an empty array
  const token = localStorage.getItem("CC_Token"); // Fetch token from localStoragee

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/banners`, {
        headers: {
          Authorization: `Bearer ${token}`, // Authorization header
        },
      });

      // Check if the response data is an array
      if (Array.isArray(response.data)) {
        setBanners(response.data);
      } else {
        console.error("Expected an array, but received:", response.data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des bannières:", error);
      toast.error("Échec de la récupération des bannières");
    }
  };

  const handleSubmit = async () => {
    if (!text || !expirationDate) {
      toast.error("Tous les champs sont requis");
      return;
    }

    try {
      // POST request to add a banner
      const response = await axios.post(
        `${baseUrl}/api/banners`,
        { text, expiration_date: expirationDate },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Authorization header
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Bannière ajoutée avec succès");
      setText("");
      setExpirationDate("");
      fetchBanners();
    } catch (error) {
      toast.error("Échec de l'ajout de la bannière");
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/api/banners/${id}`, {
        headers: { Authorization: `Bearer ${token}` }, // Authorization header
      });
      toast.success("Bannière supprimée avec succès");
      fetchBanners();
    } catch (error) {
      toast.error("Échec de la suppression de la bannière");
      console.error(error);
    }
  };

  return (
    <div className="app">
      <ToastContainer />
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src={"../assets/cej.png"} sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography variant="h6" sx={{ flexGrow: 1, color: "#ffffff" }}>
            Admin - Gérer les Bannières
          </Typography>
          <IconButton color="inherit" onClick={() => navigate("/Admin")}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ padding: "1rem", marginTop: "70px" }}>
        <Typography variant="h4" sx={{ textAlign: "center", marginBottom: "1rem" }}>
          Ajouter une Bannière
        </Typography>
        <TextField
          fullWidth
          label="Texte de la Bannière"
          value={text}
          onChange={(e) => setText(e.target.value)}
          sx={{ marginBottom: "1rem" }}
        />
        <TextField
          fullWidth
          type="date"
          label="Date d'Expiration"
          value={expirationDate}
          onChange={(e) => setExpirationDate(e.target.value)}
          sx={{ marginBottom: "1rem" }}
          InputLabelProps={{ shrink: true }}
        />
        <Button variant="contained" color="primary" fullWidth onClick={handleSubmit}>
          Soumettre
        </Button>
      </Box>

      <Box sx={{ padding: "1rem", marginTop: "20px" }}>
        <Typography variant="h5" sx={{ marginBottom: "1rem" }}>
          Bannières Actives
        </Typography>
        <List>
          {banners.map((banner) => (
            <ListItem key={banner.id} divider>
              <ListItemText primary={banner.text} secondary={`Expire le : ${banner.expiration_date}`} />
              <ListItemSecondaryAction>
                <IconButton edge="end" onClick={() => handleDelete(banner.id)}>
                  <DeleteIcon color="error" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Box>

      <Box sx={{ position: "fixed", bottom: 0, width: "100%" }}>
        <BottomNavigation sx={{ backgroundColor: "#003366" }}>
          <BottomNavigationAction label="Accueil" icon={<HomeIcon sx={{ color: "#ffffff" }} />} onClick={() => navigate("/Admin")} />
          <BottomNavigationAction label="Calendrier" icon={<CalendarTodayIcon sx={{ color: "#ffffff" }} />} onClick={() => navigate("/AdminChrono")} />
          <BottomNavigationAction label="Paiement" icon={<PaymentIcon sx={{ color: "#ffffff" }} />} onClick={() => navigate("/AdminPaiment")} />
        </BottomNavigation>
      </Box>
    </div>
  );
};

export default BannerAdmin;
